import { Box, Grid } from "@mui/material";
import { useState, useEffect } from "react";

import ModalTrigger from "../Common/ModalTrigger";
import ButtonsSelect from "../Common/ButtonsSelect";

import csv5 from "../../Data/MANCP/FoodProduct/MANCP-Results-with-quantified-residues-legal-limit-legal-limit-and-non-compliant-Processed.csv";
import csv6 from "../../Data/MANCP/FoodProduct/MANCP-Results-with-quantified-residues-legal-limit-legal-limit-and-non-compliant-Unprocessed.csv";
import HorizontalBarChartWithNegative from "../Charts/HorizontalBarChartWithNegative";

const ProcessedFoodProducts = (props) => {
  const [processedFoodCSV, setProcessedFoodCSV] = useState(csv5);
  const [processedStatus, setProcessedStatus] = useState(0);

  const handleButtonClick = (event) => {
    setProcessedStatus(event);
    if (event === 0) {
      setProcessedFoodCSV(csv5);
    } else {
      setProcessedFoodCSV(csv6);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }

    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const fields = [
    "Below quantification limit %",
    "Between quantification limit and Legal Limit %",
    "Above Legal Limit %",
    "Non-compliant %",
  ];
  const colorMap = {
    "Below quantification limit %": "#688E31",
    "Between quantification limit and Legal Limit %": "#BDC85A",
    "Above Legal Limit %": "#F9B112",
    "Non-compliant %": "#D77C47",
  };

  const retained = "Food commodity";

  return (
    <Grid
      item
      container
      direction="column"
      sx={{
        marginTop: { xs: "100px", sm: "100px", md: "90px" },
      }}
      alignContent="center"
    >
      <Grid
        item
        xs
        sx={{
          paddingRight: { xs: "24px", sm: "24px", lg: "24px" },
          paddingLeft: { xs: "20px", sm: "20px", lg: "20px" },
        }}
        className="six-one"
      >
        <Box className="sixth-one-inner">
          <h3>Results for processed food products</h3>
          <p className="paragraph">
            Of the 86,449 total samples, 7,641 (9%) were reported as processed food (excluding 1,546 samples of baby food). Compliance of these products is checked against the MRL in the raw agricultural commodity after applying a{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="processing factor"
            />
            . In 255 samples (3.3%), residues exceeding the MRL were found, of which 121 samples (1.6%) were non-compliant due to measurement uncertainty.
          </p>

          <p className="paragraph">
            The processed food products with a non-compliance rate higher than 10% and more than 10 samples reported were grape leaves and similar species, mainly pickled/marinated vegetables (40%), dried parsley (21.1%) and blended honey (11.1%).
          </p>
          <p className="paragraph">
            Of the total number of samples, 91% were unprocessed food products (77,262 samples). Out of these, 3.3% (2,574) had residues exceeding the MRL, of which 1.9% (1,456) were non-compliant due to measurement uncertainty. The unprocessed food products with a non-compliance rate higher than 10% and more than 100 samples reported were: granate apples/pomegranates (29.2%), passion fruits/maracujas (16.6%) and kales (15.1%).
          </p>
        </Box>
      </Grid>
      <Grid
        item
        xs
        sx={{ paddingLeft: { xs: "10px", sm: "10px", md: "24px" } }}
        className="six-two"
      >
        <Box>
          <Box>
            <ButtonsSelect
              firstButton="Processed"
              secondButton="Unprocessed"
              onButtonClick={handleButtonClick}
            />
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
          >
            <Box flexGrow={3} order={{ xs: 2, sm: 2, md: 1 }}>
              <HorizontalBarChartWithNegative
                title={ "Percentage of samples below/at the MRL, above the MRL, and non‑compliant" }
                height={1200}
                padding={isMobile ? [10, 20, 250, 35] : [15, 200, 60, 300]}
                marginRight={isMobile ? "auto" : "180px"}
                colorMap={colorMap}
                fields={fields}
                retained={retained}
                csv={processedFoodCSV}
              />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProcessedFoodProducts;
